const columns = [
  {
    name: 'Name',
    selector: (row) => row.full_name,
    // width: "200px"
  },
  {
    name: 'Email',
    selector: (row) => row.email,
    // width: "250px"
  },
  {
    name: 'Role',
    selector: (row) => row.candidate_role,
    // width: "130px"
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
